import * as React from "react";
import { Sheet, SheetContent, SheetTrigger } from "../sheet";
import { cn } from "../../../lib/utils";

interface ScrollableSheetProps extends React.ComponentProps<typeof Sheet> {
  trigger?: React.ReactNode;
  header?: React.ReactNode;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
  contentClassName?: string;
  showCloseButton?: boolean;
}

export function ScrollableSheet({
  trigger,
  header,
  children,
  side = "left",
  className,
  contentClassName,
  showCloseButton = false,
  ...props
}: ScrollableSheetProps) {
  return (
    <Sheet {...props}>
      {trigger && <SheetTrigger asChild>{trigger}</SheetTrigger>}
      <SheetContent 
        side={side} 
        showCloseButton={showCloseButton} 
        className={cn("w-80 p-0 gap-0", className)}
      >
        {header}
        <div 
          className={cn("flex-1 overflow-y-auto", contentClassName)} 
        >
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
}
